import { type LocationCorrectInput, type LocationCorrectSuccess } from '@terros/common'
import { useQueryClient } from '@tanstack/react-query'
import { useTantalimMutation, type TantalimMutationResponse } from '../../mutation'
import { locationLoadsKey } from '../../keys'

export function useCorrectLocations(): TantalimMutationResponse<LocationCorrectInput, LocationCorrectSuccess> {
  const queryClient = useQueryClient()

  const markLocationLoadsStale = (): void => {
    queryClient.invalidateQueries({ queryKey: locationLoadsKey(), refetchType: 'none' })
  }

  return useTantalimMutation<LocationCorrectInput, LocationCorrectSuccess>({
    url: '/location/correct',
    onSuccess: markLocationLoadsStale,
  })
}
